import { TDealType } from '@cian/api-models/offer-card/v1/get-offer-data';

import { roublePerMonthSign, roubleSign } from '../../../constants';

export const getPriceUnit = (dealType: TDealType) => (dealType === 'sale' ? roubleSign : roublePerMonthSign);
